import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-balham.css"; // Optional Theme applied to the grid
import "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";

import { globalAGGridTableHeight } from "@/components/widgets/tradeActionSummary/helper/actionSummaryHelper";

import { returnFormattedDate } from "@/lib/globalFormatterHelper";
import { formatNumberWithCommas } from "@/lib/utilities";
import { IBaseAnalyticsCombined } from "@/store/analyticsDataStore";
import { useTheme } from "next-themes";
import React, { useMemo, useRef, useState } from "react";
import {
  defaultColDefAnalytics,
  genericAnalyticsTables,
} from "../../TableGenerics";
import { ITransactionCostFilters } from "../TransactionCostIndex";

function filterTransactionCostsData({
  filteredData,
  dataFilters,
}: {
  filteredData: IBaseAnalyticsCombined[];
  dataFilters: ITransactionCostFilters;
}) {
  if (
    dataFilters &&
    dataFilters.selectedInstruments &&
    dataFilters.selectedInstruments.length > 0
  ) {
    return filteredData.filter((item) =>
      dataFilters.selectedInstruments.includes(item.instrumentType),
    );
  }
  return filteredData;
}

const TransactionCostAllData = ({
  filteredData,
  dataFilters,
}: {
  filteredData: IBaseAnalyticsCombined[];
  dataFilters: ITransactionCostFilters;
}) => {
  const { theme } = useTheme();
  const gridRef = useRef<AgGridReact>(null);

  const [colDefs] = useState([
    {
      field: "dateTimeSent",
      colId: "dateTimeSent",
      headerName: "Date",
      valueFormatter: (params: any) => {
        return returnFormattedDate(params.value);
      },
      maxWidth: 120,
    },
    {
      field: "securityType",
      colId: "securityTypeTransactionCost",
      maxWidth: 100,
    },
    {
      field: "securityName",
      colId: "securityName",
      maxWidth: 200,
    },
    {
      field: "direction",
      colId: "direction",
      maxWidth: 100,
    },
    {
      field: "currency",
      colId: "currency",
      maxWidth: 100,
    },
    {
      field: "mid",
      colId: "mid",
      maxWidth: 100,
    },
    {
      field: "cover",
      colId: "cover",
      maxWidth: 100,
    },
    {
      field: "spreadToMid",
      colId: "spreadToMidTransactionCost",
      maxWidth: 110,
      cellRenderer: (params: any) => {
        if (Number.isNaN(Number(params.value))) {
          return "";
        }
        return `$${Number(params.value).toFixed(2)}`;
      },
    },
    {
      field: "DV01",
      headerName: "DV01",
      colId: "DV01TransactionCost",
      maxWidth: 110,
      cellRenderer: (params: any) => {
        if (Number.isNaN(Number(params.value))) {
          return "";
        }
        return `$${formatNumberWithCommas(Number(params.value))}`;
      },
    },
    {
      field: "tradeCostVsMid",
      colId: "tradingCostVsMid",
      maxWidth: 150,
      cellRenderer: (params: any) => {
        if (Number.isNaN(Number(params.value))) {
          return "";
        }
        return `$${Number(params.value)}`;
      },
    },
  ]);

  const style = useMemo(
    () => genericAnalyticsTables(theme) as React.CSSProperties,
    [theme],
  );

  const finalTransactionData = useMemo(() => {
    return filterTransactionCostsData({
      filteredData,
      dataFilters,
    });
  }, [filteredData, dataFilters]);

  return (
    <div className="flex h-full w-full flex-col">
      <div
        id="CPReportTable"
        className={`${theme == "dark" ? "ag-theme-balham-dark" : "ag-theme-balham"} flex h-full w-full flex-col  `}
        style={style}
      >
        <AgGridReact
          ref={gridRef}
          rowData={finalTransactionData}
          columnDefs={colDefs}
          defaultColDef={defaultColDefAnalytics}
          columnMenu={"new"} //do not delete, affects header menus
          detailRowAutoHeight={true}
          getRowId={(params) => params.data.id}
          // rowSelection={"single"}
          suppressAggFuncInHeader={true}
          suppressDragLeaveHidesColumns={true}
          // Style:
          rowHeight={globalAGGridTableHeight}
          scrollbarWidth={6}
          // groupDisplayType={"groupRows"}
          animateRows={true} // Smoother transition of rows when updates occur - needs 'getRowId' for this to work.
          maintainColumnOrder={true}
          // components={}
          tooltipShowDelay={1}
          domLayout="normal"
        />
      </div>
    </div>
  );
};

export default TransactionCostAllData;
